import React from 'react';
import { StickyNav } from './components/StickyNav';
import { Hero } from './components/Hero';
import { GutHealthExplanation } from './components/GutHealthExplanation';
import { DamageFactors } from './components/DamageFactors';
import { UrgencyTimeline } from './components/UrgencyTimeline';
import { OurStory } from './components/OurStory';
import { AnifitSolution } from './components/AnifitSolution';
import { PowerDarm } from './components/PowerDarm';
import { TransitionPlan } from './components/TransitionPlan';
import { BenefitsGrid } from './components/BenefitsGrid';
import { CTASection } from './components/CTASection';
import { Closing } from './components/Closing';
import { ExitPopup } from './components/ExitPopup';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <StickyNav data-id="element-1" />
      <div className="pt-12" data-id="element-2">
        <Hero data-id="element-3" />
        <GutHealthExplanation data-id="element-4" />
        <DamageFactors data-id="element-5" />
        <UrgencyTimeline data-id="element-6" />
        <OurStory data-id="element-7" />
        <AnifitSolution data-id="element-8" />
        <PowerDarm data-id="element-9" />
        <TransitionPlan data-id="element-10" />
        <BenefitsGrid data-id="element-11" />
        <CTASection data-id="element-12" />
        <Closing data-id="element-13" />
      </div>
      <ExitPopup data-id="element-14" />
    </div>;
}